import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { Box, Button } from "@mantine/core";
import { mediaUrl } from "@/lib/config/app";
import { getShopConfig } from "@/server/shop/get-shop-config";
export default function HeroWithImage(t0) {
  const $ = _c(26);
  const {
    fbanner
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getShopConfig();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const nshop = t1;
  const imageAlt = fbanner?.image_alt || fbanner?.heading || "Featured Banner";
  let t2;
  if ($[1] !== fbanner.heading) {
    t2 = <h2 className="text-2xl lg:text-4xl uppercase">{fbanner.heading}</h2>;
    $[1] = fbanner.heading;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== fbanner.promo_text) {
    t3 = <h3 className="my-3 text-xl relative py-3 ps-10 pe-10 w-fit border-l-0 drop-shadow-gray-500 drop-shadow-xs -left-10 font-heading text-slate-700 leading-tight before:bg-white before:top-0 before:left-0 before:absolute before:h-full before:inset-0 before:w-full before:-z-1 before:[clip-path:polygon(0_0,100%_0,calc(100%-20px)_100%,0_100%)]">{fbanner.promo_text}</h3>;
    $[3] = fbanner.promo_text;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== fbanner.subheading) {
    t4 = <p className="text-base lg:text-xl mb-4">{fbanner.subheading}</p>;
    $[5] = fbanner.subheading;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `${fbanner.button_link}`;
  let t6;
  if ($[7] !== fbanner.button_text) {
    t6 = <Button size="lg" color="var(--color-primary)" ff="var(--font-heading)" fw={400} miw={175}>{fbanner.button_text}</Button>;
    $[7] = fbanner.button_text;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== fbanner.heading || $[10] !== t5 || $[11] !== t6) {
    t7 = <Link href={t5} title={fbanner.heading}>{t6}</Link>;
    $[9] = fbanner.heading;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t7) {
    t8 = <div className="col-span-12 lg:col-span-8"><div className="px-2 py-3 lg:p-4 relative">{t2}{t3}{t4}{t7}</div></div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== fbanner.heading || $[19] !== fbanner.image_url || $[20] !== imageAlt) {
    t9 = <div className="col-span-12 lg:col-span-3 flex justify-center relative aspect-square">{fbanner.image_url ? <Image src={`${mediaUrl}${fbanner.image_url}`} alt={imageAlt} className="object-contain" quality={60} priority={true} fill={true} fetchPriority="high" sizes="(max-width: 1024px) 100vw, 25vw" /> : <Image src={`${nshop.assets.favicon}`} alt={fbanner?.heading || "Banner"} fetchPriority="high" priority={true} width={330} height={330} />}</div>;
    $[18] = fbanner.heading;
    $[19] = fbanner.image_url;
    $[20] = imageAlt;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="col-span-12 lg:col-span-1" />;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t8 || $[24] !== t9) {
    t11 = <Box className="herobanner pt-2 lg:py-3 bg-slate-50"><div className="max-w-7xl mx-auto px-2"><div className="grid grid-cols-12 items-center h-full shadow-sm bg-sky-100 border-2 border-sky-100 rounded overflow-hidden lg:py-10">{t8}{t9}{t10}</div></div></Box>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}